import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICurriculumV2 } from '.';
import { ApiPaths } from '../../../api/APIPaths';

const apiDataProvider = new APIDataProvider();

export const getCurriculumsV2 = createAsyncThunk(
  '/curriculumsV2/list',
  async () => {
    const response = await apiDataProvider.get<TApiResponse<ICurriculumV2[]>>(
      ApiPaths.curriculums
    );

    return response.data;
  }
);

export default getCurriculumsV2;
